import React from 'react';
import styled from '@emotion/styled';
import { useComponentTheme } from '../useComponentTheme';
import { withSpacingStyles } from '../withSpacingStyles';

type Props = {
  align: 'center' | 'left' | 'right',
  children: React.Node,
  className?: string,
  radius: string,
  type: 'white' | 'brand' | 'black' | 'success' | 'info' | 'danger',
  dataTest?: string,
  isInvalid: boolean,
  mode: 'default' | 'RewardCounter' | 'CategoryHeader',
  ariaHidden?: boolean,
};

const _Badge = ({
  align = 'left',
  children,
  className,
  radius = 'ellipse',
  type,
  dataTest = 'badge',
  isInvalid,
  mode = 'default',
  ariaHidden,
}: Props) => {
  const componentTheme = useComponentTheme(theme => theme.components.Badge, mode);

  return (
    <BadgeWrapper
      align={align}
      className={className}
      componentTheme={componentTheme}
      radius={radius}
      type={type}
      data-test={dataTest}
      isInvalid={isInvalid}
      aria-hidden={ariaHidden}
    >
      {children}
    </BadgeWrapper>
  );
};

export const Badge = withSpacingStyles(_Badge);

const BadgeWrapper = styled('span', {
  shouldForwardProp: prop => !['align', 'componentTheme', 'isInvalid', 'radius', 'type'].includes(prop),
})(
  ({ align, radius, theme, type, componentTheme, isInvalid }) => `
  width: fit-content;
  background: ${componentTheme.backgroundColor || theme.color[type]};
  color: ${isInvalid ? theme.color.danger : componentTheme.color || theme.color.white};
  ${componentTheme.borderColor && `border: 2px solid ${componentTheme.borderColor}`};
  border-radius: ${theme.borderRadius[radius]};
  padding: 4px 8px;
  text-align: ${align};
`
);
